export default __webpack_public_path__ + "static/media/footer.63bd7acd.svg";